// material-ui
import { createTheme } from '@mui/material/styles';

// types
import { PaletteThemeProps } from 'types/theme';
import Default from './theme/default';

// ==============================|| DEFAULT THEME - PALETTE  ||============================== //

const Palette = () => {


  const paletteColor: PaletteThemeProps = Default();

  return createTheme({
    palette: {
      mode: 'light',
      common: {
        black: '#000',
        white: '#fff'
      },
      ...paletteColor,
      text: {
        primary: paletteColor.grey[700],
        secondary: paletteColor.grey[500],
        disabled: paletteColor.grey[400]
      },
      action: {
        disabled: paletteColor.grey[300]
      },
      divider: paletteColor.grey[200],
      background: {
        paper: paletteColor.grey[0],
        default: paletteColor.grey.A50
      }
    }
  });
};

export default Palette;
